import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AbcCoreModule } from './abc-core.module';
import { ProfileSelectionComponentInfo } from './authentication/src/lib/profile-selection/profile-selection-component-info';
import { CacheService, DataService, ObjectSpaceService, PersistenceService, QueryService } from './data/src';
import { ErrorHandlingService } from './error-handling/src';
import { LoggingService } from './logging/src';
import { UrlHelper } from './helpers';

@Injectable({
  providedIn: AbcCoreModule,
})
export class CoreService {
  public static areProfilesSupported(router: Router): boolean {
    return ProfileSelectionComponentInfo.areProfilesSupported(router);
  }

  constructor(
    public router: Router,
    public data: DataService,
    public objectSpace: ObjectSpaceService,
    public log: LoggingService,
    public error: ErrorHandlingService,
    public cache: CacheService,
    public query: QueryService,
    public persist: PersistenceService,
  ) {}

  public initialize(): void {
    if (CoreService.areProfilesSupported(this.router)) {
      this.objectSpace.initialize();
    }
  }

  public defaultTargetWindowName: string = '_blank';

  public openWindow(url?: string | URL, target?: string, features?: string): Window {
    if (!target) {
      target = this.defaultTargetWindowName;
    }
    return window.open(url, target, features);
  }

  public buildUrl(base: string, ...path: string[]): string {
    return UrlHelper.buildUrl(base, ...path);
  }
}
